<template>
	<div ref="charts"></div>
</template>

<script>
	import {getStore, mapStore} from './store.js'
	import * as echarts from 'echarts'
	
	export default {
		data() {
			return {
				...getStore(this, 'digitalStore')
			}
		},

		computed: {
			...mapStore('digitalStore', ['registerChart', 'px'])
		},

		mounted() {
			this.echartsObj = echarts.init(this.$refs.charts);
			this.registerChart(this.echartsObj);
		},

		methods: {
			update() {
				this.request({
					url: '/visual/data/daily_trend',
					success: data => {
						this.echartsObj.clear();
						this.echartsObj.setOption({
							tooltip: {
								trigger: 'axis',
								axisPointer: {
									type: 'shadow'
								}
							},
							legend: {
								bottom: '0',
								left: 'center',
								itemWidth: this.px(14),
								itemHeight: this.px(4),
								textStyle: {
									fontSize: this.px(12),
									color: '#ABFFE9'
								}
							},
							grid: {
								top: this.px(10),
								bottom: this.px(50),
								left: this.px(50),
								right: this.px(50)
							},
							yAxis: {
								type: 'value',
								axisLine: {
									show: false
								},
								axisLabel: {
									fontSize: this.px(13),
									color: '#ABFFE9'
								},
								splitLine: {
									lineStyle: {
										color: 'rgba(255,255,255,.05)'
									}
								}
							},
							xAxis: {
								type: 'category',
								axisLine: {
									show: true,
									lineStyle: {
										color: '#4E8AB1'
									}
								},
								axisLabel: {
									fontSize: this.px(12),
									color: '#31C6FD'
								},
								data: data.daily_trend.map(item => item.date_label)
							},
							yAxis: [{
								type: 'value',
								axisLine: {
									show: false
								},
								axisLabel: {
									fontSize: this.px(13),
									color: '#fff'
								},
								splitLine: {
									lineStyle: {
										color: 'rgba(255,255,255,.05)'
									}
								}
							}, {
								type: 'value',
								axisLine: {
									show: false
								},
								axisLabel: {
									fontSize: this.px(13),
									color: '#fff'
								},
								splitLine: {
									show: false
								}
							}],
							series: [{
								name: '新增',
								type: 'bar',
								barWidth: this.px(24),
								itemStyle: {
									normal: {
										barBorderRadius: [4, 4, 0, 0],
										color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
											offset: 0,
											color: '#07BFED'
										}, {
											offset: 1,
											color: '#0A71F8'
										}], false)
									}
								},
								data: data.daily_trend.map(item => item.new_count)
							}, {
								name: '完工',
								type: 'line',
								smooth: true,
								yAxisIndex: 1,
								color: '#07F3A4',
								data: data.daily_trend.map(item => item.completed_count)
							}]
						});
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
	
</style>